(function() {
    /**
     *
     */
    angular.module('graph').service('ph-touch-service', [function () {
        var $touched = {};

        this.$touch = function ($module, $call) {
            if ($touched[$module] !== 1) {
                $touched[$module] = 1;

                $call();
            }
        };

        this.$is = function ($module) {
            return $touched[$module] === 1 ? true : false;
        };

        this.$watch = function ($scope, $module, $call) {
            $scope.$on('touch', function ($event, $data) {
                if ($module === $data) $call();
            });
        };
    }]);

    /**
     *
     */
    angular.module('graph').service('ph-query-service', [function () {
        var $query = function($data) {
            var self = this;

            if (typeof $data !== 'object')
                $data = {};

            this.set = function($key, $val) {
                $data[$key] = $val;
                return self;
            };

            this.get = function($key) {
                return $data[$key];
            };

            this.str = function($key) {
                var line = [];

                for (let $key in $data) {
                    line.push($key + '=' + $data[$key]);
                }

                return line.join('&');
            };
        };

        this.new = function($data) {
            return new $query($data);
        };
    }]);

    /**
     *
     */
    angular.module('graph').service('ph-feed-term', ['ph-core', function ($core) {
        var $request = null;

        this.$get = function () {
            if ($request === null)
                $request = $core.get('/xhr/feed/term');

            return $request;
        }
    }]);

    /**
     *
     */
    angular.module('graph').service('ph-date-service', ['$cookies', function ($cookies) {
        var $tz = $cookies.get('gputz');
        var $ln = ($cookies.get('gpuln') == 'undefined') ? 'en' : $cookies.get('gpuln');

        this.$convert = function ($time) {
            return (typeof $tz !== 'undefined') ?
                moment.tz($time, $tz) : moment($time);
        };

        this.$parse = function ($time) {
            return moment($time);
        };

        this.$new = function ($date) {
            var $iso = ($date) ? moment($date) : moment();
            return (typeof $tz !== 'undefined') ?
                $iso.tz($tz) : $iso.local();
        };

        this.$tz = function ($date, $format) {
            $format = (typeof $format === 'undefined') ? 'YYYY-MM-DD' : $format;
            return (typeof $tz !== 'undefined') ?
                moment.tz($date, $format, $tz) : moment($date, $format);
        };

        this.$now = this.$new;

        this.$interval = function ($start, $end, $interval, $format) {
            var start  = this.$new($start);
            var future = this.$new($end);
            var range  = [];

            for (var i = start.unix() * 1000; i < future.unix() * 1000; i = i + $interval) {
                range.push(this.$convert(i).format(
                    (typeof $format === 'undefined') ?
                        'YYYY-MM-DD' : $format
                    )
                )
            }
            return range;
        };

        this.moment = function ($instance) {
            return (typeof $tz !== 'undefined') ?
                moment($instance).tz($tz) : moment($instance).local();
        };

        this.$generate = {
            "timespamp": function ($time) {
                var $repeat = +(60 / $time);
                var $result = {};
                var $format;
                var $counts;
                var $hours, $minutes, $counts;

                for (var $i = 0; $i < 24; $i++) {
                    for (var $j = 0; $j < $repeat; $j++) {
                        $counts = ($j * $time);

                        $hours = (
                            $i < 10 ? '0' + $i : $i
                        );

                        $minutes = (
                            $counts < 10 ? '0' + $counts : $counts
                        );

                        $format = $hours + ':' + $minutes;

                        if ($format !== '00:00')
                            $result[($hours * 60) + +($minutes)] = $format;

                        // if ($counts !== 0) {
                        // }
                    }
                }

                return $result;
            }
        };
    }]);

    /**
     *
     */
    angular.module('graph').service('ph-route-params-service', ['$location', function ($location) {
        this.$url = $location.absUrl();

        this.$getQueryByName = function (name) {
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(this.$url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };

        this.$getQuery = function () {
            return (typeof this.$url.split('?')[1] === 'undefined') ? '' : this.$url.split('?')[1];
        };
    }]);
})();
